// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__15yNj","footer":"Form_footer__Ryuj-"};